import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Button from '../SelectValue/Button';
import AccountBalanceWallet from '@mui/icons-material/AccountBalanceWallet';
import MonetizationOn from '@mui/icons-material/MonetizationOn';
import Handshake from '@mui/icons-material/Handshake';
import Verified from '@mui/icons-material/Verified';
import Insights from '@mui/icons-material/Insights';

function Benefit() {
  const benefits = [
    {
      icon: <AccountBalanceWallet sx={{ fontSize: 40, color: '#fff' }} />,
      title: 'Borrow Without Interest',
      description: 'Access your savings when you need it most - without paying interest. Your money keeps earning halal returns.',
      link: '/borrow',
    },
    {
      icon: <MonetizationOn sx={{ fontSize: 40, color: '#fff' }} />,
      title: 'Earn Quarterly & Annual Returns',
      description: 'Circles let you earn consistent quarterly and annual returns, unlike traditional group savings.',
      link: '/returns',
    },
    {
      icon: <Handshake sx={{ fontSize: 40, color: '#fff' }} />,
      title: 'Community-Powered Growth',
      description: 'Pooling funds with family or colleagues unlocks bigger, halal investment opportunities.',
      link: '/community',
    },
    {
      icon: <Verified sx={{ fontSize: 40, color: '#fff' }} />,
      title: '100% Shariah-Compliant',
      description: 'No riba, no hidden conditions, no exploitation. Built on ethical Islamic finance principles.',
      link: '/shariah',
    },
    {
      icon: <Insights sx={{ fontSize: 40, color: '#fff' }} />,
      title: 'Track & Grow with Ease',
      description: 'Monitor contributions, returns, and withdrawals in real-time via the Halal Wealth app.',
      link: '/track',
    },
  ];

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  return (
    <div className="px-6 sm:px-24 py-8 sm:py-16 mb-20 bg-text-gray">
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="text-[24px] sm:text-[44px] font-[400]"
      >
        Benefits of{' '}
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#FF75E8] to-[#8046F2]">
          Joining a Circle
        </span>
      </motion.h1>

      <motion.div
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3"
      >
        {benefits.map((benefit, index) => (
          <motion.div
            key={index}
            variants={item}
            // className="relative flex flex-col items-center p-6 rounded-lg bg-gradient-to-br from-[#FF75E8]/10 to-[#8046F2]/10 border border-[#8046F2]/20 hover:border-[#8046F2]/50 transition-all duration-300"
            className="relative flex flex-col items-center p-6 rounded-lg bg-gradient-to-br from-[#FF75E8]/10 to-[#8046F2]/10 border border-[#8046F2]/20 hover:border-[#8046F2]/50 transition-all duration-300"
          >
            <motion.div
              className="w-16 h-16 mb-4 rounded-full flex items-center justify-center bg-gradient-to-r from-[#FF75E8] to-[#8046F2]"
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.3 }}
            >
              {benefit.icon}
            </motion.div>
            <h3 className="text-[18px] sm:text-[20px] font-[600] text-[#1a1a1a] text-center">
              {benefit.title}
            </h3>
            <p className="text-[14px] sm:text-[16px] font-[400] text-center text-[#4a4a4a] mt-2">
              {benefit.description}
            </p>
            {/* <div className="mt-4">
              <Link to={benefit.link}>
                <Button
                  name="Learn More"
                  className="text-[#8046F2] hover:text-white hover:bg-[#8046F2] border border-[#8046F2] rounded-full px-4 py-1 text-[14px] transition-all duration-300"
                />
              </Link>
            </div> */}
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}

export default Benefit;